import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, ValueObject } from '@digibricks/domains';
import { OverviewReport } from './overview-report';
import { SubmissionScoreReport } from './score-report/submission-score-report';
import { SectionScoreReport } from './score-report/section-score-report';
import { ScoreReport } from './score-report/score-report';
export var GeneralInformationReport = /*#__PURE__*/function (_ValueObject) {
  _inherits(GeneralInformationReport, _ValueObject);

  var _super = _createSuper(GeneralInformationReport);

  function GeneralInformationReport() {
    _classCallCheck(this, GeneralInformationReport);

    return _super.apply(this, arguments);
  }

  _createClass(GeneralInformationReport, [{
    key: "overviewReport",
    get: function get() {
      return this.props.overviewReport;
    }
  }, {
    key: "submissionScoreReports",
    get: function get() {
      return this.props.submissionScoreReports;
    }
  }, {
    key: "sectionScoreReports",
    get: function get() {
      return this.props.sectionScoreReports;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [{
        argument: props.overviewReport,
        argumentName: 'Overview Report'
      }, {
        argument: props.submissionScoreReports,
        argumentName: 'Submission Score Report'
      }, {
        argument: props.sectionScoreReports,
        argumentName: 'Section Score Report'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new GeneralInformationReport(props));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      var overviewReport = data.overviewReport,
          submissionScoreReports = data.submissionScoreReports,
          sectionScoreReports = data.sectionScoreReports;
      var overviewReportResultOrError = OverviewReport.create({
        maxScore: overviewReport.maxScore || 0,
        minScore: overviewReport.minScore || 0,
        averageScore: overviewReport.averageScore || 0,
        totalAttendees: overviewReport.totalAttendees
      });
      if (overviewReportResultOrError.isFailure) return Result.fail(overviewReportResultOrError.error);
      var submissionScoreReportsResultOrError = submissionScoreReports.map(function (submissionScoreReport) {
        var score = submissionScoreReport.score,
            totalAttendeeAchieve = submissionScoreReport.totalAttendeeAchieve;
        return SubmissionScoreReport.create({
          score: score,
          totalAttendeeAchieve: totalAttendeeAchieve
        });
      });
      var submissionScoreReportsResultOrErrorCombined = Result.combineArray(submissionScoreReportsResultOrError);
      if (submissionScoreReportsResultOrErrorCombined.isFailure) return Result.fail(submissionScoreReportsResultOrErrorCombined.error);
      var sectionScoreReportsResultOrError = sectionScoreReports.map(function (sectionScoreReport) {
        var sectionId = sectionScoreReport.sectionId,
            formReleaseId = sectionScoreReport.formReleaseId,
            scoreSummary = sectionScoreReport.scoreSummary;
        var scoreSummaryResultOrError = scoreSummary.map(function (scoreSummary) {
          var score = scoreSummary.score,
              totalAttendeeAchieve = scoreSummary.totalAttendeeAchieve;
          return ScoreReport.create({
            score: score,
            totalAttendeeAchieve: totalAttendeeAchieve
          });
        });
        var scoreSummaryResultOrErrorCombined = Result.combineArray(scoreSummaryResultOrError);
        if (scoreSummaryResultOrErrorCombined.isFailure) return Result.fail(scoreSummaryResultOrErrorCombined.error);
        var scoreSummaryResult = scoreSummaryResultOrErrorCombined.getValue();
        return SectionScoreReport.create({
          sectionId: sectionId,
          formReleaseId: formReleaseId,
          scoreSummary: scoreSummaryResult
        });
      });
      var sectionScoreReportsResultOrErrorCombined = Result.combineArray(sectionScoreReportsResultOrError);
      if (sectionScoreReportsResultOrErrorCombined.isFailure) return Result.fail(sectionScoreReportsResultOrErrorCombined.error);
      var overviewReportResult = overviewReportResultOrError.getValue();
      var submissionScoreReportsResult = submissionScoreReportsResultOrErrorCombined.getValue();
      var sectionScoreReportsResult = sectionScoreReportsResultOrErrorCombined.getValue();
      return this.create({
        overviewReport: overviewReportResult,
        submissionScoreReports: submissionScoreReportsResult,
        sectionScoreReports: sectionScoreReportsResult
      });
    }
  }]);

  return GeneralInformationReport;
}(ValueObject);